const autocompleteModalDocEmployee = {
  documentTypes: 'Document Type',
  document: 'Document'
};

export default autocompleteModalDocEmployee;
